<template>
  <div>
    <van-popup
      v-model="creates"
      position="right"
      :style="{ height: '100%',width:'100%', background: '#f5f5f5' }"
    >
      <van-nav-bar fixed>
        <div slot="title">选择年级</div>
        <div slot="right" @click="cancelDate">关闭</div>
      </van-nav-bar>
      <div class="select-people">
        <div class="select-box">
          <div class="select-column">
            <div
              class="select-item"
              v-for="(item,index) in layerList"
              :key="index"
              v-bind:class="index===schoolIndex ? 'active':''"
              @click="selectSchool(item,index)"
            >{{item.label}}</div>
          </div>

          <div class="select-column">
            <div
              class="select-item"
              v-for="(item,index) in gradelList"
              :key="index"
              v-bind:class="index===gradelIndex ? 'active':''"
              @click="selectGradel(item,index)"
            >{{item.label}}</div>
          </div>

          <div class="select-column">
            <div
              class="select-item"
              v-for="(item,index) in classList"
              :key="index"
              v-bind:class="index===classIndex ? 'active':''"
              @click="selectClass(item,index)"
            >{{item.label}}</div>
          </div>
        </div>
      </div>
      <div class="sigle-bottom-btn">
        <van-button type="info" plain round @click="cancelDate">取消</van-button>
        <van-button type="info" round @click="okDate">确认</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: ["layerList", "isShowSelectLayer"],
  name: "SelectLayer",
  computed: {
    creates: {
      get: function() {
        return this.isShowSelectLayer;
      },
      set: function(ed) {
        this.isModal = ed;
      }
    }
  },
  data() {
    return {
      isModal: false,
      schoolIndex: -1,
      gradelIndex: -1,
      classIndex: -1,
      schoolID: 0,
      gradeID: 0,
      classID: 0,
      schoolList: [],
      gradelList: [],
      classList: [],

      dataCurrent: {},
      dataList: [],
      school: '',
      grade: '',
      classes: ''

    };
  },
  created() {
    this.schoolIndex = 0;
    this.gradelIndex = -1;
    this.gradelIndex = -1;
    this.schoolID = 0;
    this.gradeID = 0;
    this.classID = 0;
  },
  mounted() {},
  methods: {
    // 取消选择时间
    cancelDate() {
      this.$emit("LayerClose", false);
    },

    // 选择校区
    selectSchool(val, i) {
      this.dataCurrent = {};
      this.schoolIndex = i;
      this.schoolID = val.value;
      this.gradelList = val.children;
      this.gradelIndex = -1;
      this.classIndex = -1;
      this.classList = [];

      this.dataList = [];
      this.school = val;
      this.dataList.push(this.school);
      
      console.log(this.dataList)
    },
    // 选择年级
    selectGradel(val, i) {
      this.gradelIndex = i;
      this.gradeID = val.value;
      this.classList = val.children;
      this.classIndex = -1;

      this.dataList = [];
      this.grade = val;
      this.dataList.push(this.school);
      this.dataList.push(this.grade);
      
      console.log(this.dataList)
    },
    // 选择班级数据
    selectClass(val, i) {
      this.classIndex = i;
      this.classID = val.value;
      
      this.dataList = [];
      this.classes = val;
      this.dataList.push(this.school);
      this.dataList.push(this.grade);
      this.dataList.push(this.classes);
      
      console.log(this.dataList)
    },
    // 点击确定
    okDate() {
      // 子组件值传入父组件
      this.dataCurrent = this.dataList
      // 测试:去掉所有年级所有学科所有班级的筛选就不限制了
      // if(this.dataCurrent.length === 3){
      //   this.$emit("SelectLayer", this.dataCurrent);
      //   this.cancelDate();
      // } else {
      //   return this.$toast.fail('请选择年级班级');
      // }
  
      this.$emit("SelectLayer", this.dataCurrent);
      this.cancelDate();

    }
  }
};
</script>
<style scoped lang="less">
.select-people {
  // position: fixed;
  // top: 80px;
  // left: 0;
  // right: 0;
  // z-index: 111;
  padding-top: 90px;
  background: #fff;
  overflow: auto;
  height: 100%;
  padding-bottom: 100px;
}
.sigle-bottom-btn {
  height: 110px;
  line-height: 110px;
  background: #000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 99999 !important;
  button {
    flex: 0.5;
    margin: 17px 30px;
  }
}
.select-box {
  display: flex;
  .select-column {
    flex: 1;
    border-right: 1px solid #eaeaea;
    padding: 0 10px;
    .select-item {
      padding: 20px 0;
      min-width: 33vw;
    }
  }
}
.active {
  color: #2980fe;
}
</style>
